
import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import '@/permission'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/materialicon/css/materialdesignicons.min.css'
Vue.use(ElementUI);

import ElTableEdit from "el-table-edit";//可编辑表格
Vue.use(ElTableEdit);
import '@/components/element/el-dialog/directives';//可拖拽dialog


//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import "default-passive-events";
import pub from '@/utils/public'
Vue.config.productionTip = false;
Vue.prototype.$sqlOpt = store.state.sqlOpt;
Vue.prototype.$pub = pub;
Vue.prototype.$bus = new Vue();

/* eslint-disable no-new */
new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
});
